"use client";

import { Bed } from "lucide-react";
import RenderImage from "@/components/atoms/RenderImage";
import { cn } from "@/lib/utils";
import type { PortfolioRoomsResult } from "@/components/modules/portfolio/hooks/usePortfolioUtils";
import type { BusinessUnitsSchemaType, GetRealEstateManagementSchemaType } from "@/components/modules/portfolio/api/schemas/schemas";
type Props = {
  resource: PortfolioRoomsResult;
  selectedUnitId?: string | null;
  currentUnitId?: string | null;
  currentLabel?: string;
  desktopColumns?: 3 | 4 | 5;
  onSelectUnit: (unit: BusinessUnitsSchemaType, portfolio: GetRealEstateManagementSchemaType) => void;
};
export function PortfolioUnitGrid({
  resource,
  selectedUnitId,
  currentUnitId,
  currentLabel,
  desktopColumns = 3,
  onSelectUnit
}: Props) {
  return <div className="space-y-6" data-sentry-component="PortfolioUnitGrid" data-sentry-source-file="PortfolioUnitGrid.tsx">
      {resource.portfolios.map(portfolio => <div key={portfolio.id} className="space-y-3">
          <p className="font-semibold text-primary">{portfolio.title}</p>
          {portfolio.businesses?.map(business => <div key={business.id} className={cn("grid gap-4 grid-cols-[repeat(3,minmax(0,120px))]", desktopColumns === 5 ? "sm:grid-cols-[repeat(5,minmax(0,120px))]" : desktopColumns === 4 ? "sm:grid-cols-[repeat(4,minmax(0,120px))]" : "sm:grid-cols-[repeat(3,minmax(0,120px))]")}>
              {business.units.map(unit => {
          const isSelected = selectedUnitId === unit.id;
          const isCurrent = !!currentUnitId && currentUnitId === unit.id && !isSelected;
          const hasImage = !!unit.realEstateAssociated;
          return <div onClick={() => onSelectUnit(unit, portfolio)} key={unit.id} className="cursor-pointer flex flex-col">
                    <div className={cn("aspect-square w-full rounded-xl overflow-hidden relative transition-all", isSelected && "ring-3 ring-blue-500 ring-offset-2 ring-offset-background", isCurrent && "ring-2 ring-emerald-500 ring-offset-2 ring-offset-background", hasImage ? "border border-border" : "bg-muted border-2 border-dashed border-border-strong flex items-center justify-center hover:bg-muted-strong transition-colors")}>
                      {hasImage ? <RenderImage src={unit.realEstateAssociated!.thumbnail || unit.realEstateAssociated!.picture} alt={unit.title} className="w-full h-full object-cover" /> : <Bed className="w-8 h-8 text-faint-foreground" />}
                      {isCurrent && currentLabel && <span className="absolute top-2 left-2 rounded-full bg-emerald-500 text-white text-[10px] font-semibold uppercase tracking-wide px-2 py-0.5">
                          {currentLabel}
                        </span>}
                    </div>
                    <p className="text-sm font-semibold text-foreground-heading mt-2 capitalize truncate">
                      {unit.title}
                    </p>
                    {hasImage && <p className="text-xs text-faint-foreground truncate">
                        {unit.realEstateAssociated!.title}
                      </p>}
                  </div>;
        })}
            </div>)}
        </div>)}
    </div>;
}